module.exports = __webpack_public_path__ + "img/tournament-2020.fdde6c9f.jpg";